import React, { useState, useEffect } from "react";
import { Divider, Image, Modal, Icon } from "semantic-ui-react";
// Mui
import MuiRadio from "@mui/material/Radio";
import makeStyles from "@mui/styles/makeStyles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import { FormattedMessage } from "react-intl";

// UX
import DialogReadMore from "./DialogReadMore";

// Types
import { devModeType, registerInfo } from "./TypeModal";

// Styles
import "./RegisterCSS.scss";
import { State } from "bplus-lib/MobSmartRegisterInterface";
import { policy, privacyPolicy, privacyPolicyEn } from "bplus-lib/register/DataPolicy";

const COLOR = {
  primary: "var(--primary-theme-color)",
  font_black: "#393939",
  DarkGray_Line: "#9F9F9F",
};

const IMAGES = {
  bg: "/images/register/lobby_background.png",
  bPlusLogo: "/images/expansion/logo_48.png",
  flagThai: "/images/register/flag_thai.png",
  flagUS: "/images/register/flag_english_us.png",
};

const Langue = [
  { flag: IMAGES.flagThai, langue: "ภาษาไทย", key: "th" },
  { flag: IMAGES.flagUS, langue: "English", key: "en" },
];

type MainLobbyProps = {
  onEvent: (e: any) => any;
  history: any;
  loading?: boolean;
  setProp?: any;
  devMode?: devModeType;
  registerInfo?: registerInfo;
} & Pick<State, "safeAreaTop"| "language">;

const useStyles = makeStyles((theme) => ({
  dialog: {
    "& .MuiDialogContent-root": {
      overflowY: "unset",
    },
  },
}));

const MainLobby: React.FunctionComponent<MainLobbyProps> = (props) => {
  const classes = useStyles();

  // open
  const [openSelectLangue, setOpenSelectLangue] = useState<boolean>(false);
  const [openPolicy, setOpenPolicy] = useState<
    "policy" | "privacy-policy" | undefined
  >(undefined);

  const [selectLangue, setSelectLangue] = useState<string>("th");
  const [pattern, setPattern] = useState<string>("");

  useEffect(() => {
    if (window.mobile?.getDevMode) {
      window.mobile?.getDevMode();
    }

    if (window.mobile?.getLocaleLanguage) {
      if (typeof window.mobile.getLocaleLanguage === "object") {
        // iOS
        window.mobile?.getLocaleLanguage.then((lang: any) => {
          setSelectLangue(lang);
        });
      } else {
        // android
        const localeLanguage = window.mobile?.getLocaleLanguage();
        setSelectLangue(localeLanguage);
      }
    }
    props.setProp("loading", false);
    props.setProp("registerInfo", {});
  }, []);

  useEffect(() => {
    if (pattern.includes("121212121212")) {
      console.log("devMode 1:");
      setDevModeNative(true, 1);
    } else if (pattern.includes("122222222222")) {
      console.log("devMode 2:");
      setDevModeNative(true, 2);
    } else if (pattern.includes("111111111111")) {
      console.log("devMode 3:");
      setDevModeNative(true, 3);
    }
  }, [pattern]);

  const setDevModeNative = (active: boolean, version: number) => {
    if (window.mobile?.saveDevMode) {
      window.mobile?.saveDevMode(`${active}`, `${version}`);
      setPattern("");
    }
  };

  const handleHistoryGoTo = (action: string) => {
    switch (action) {
      case "login":
        props.history.push("/login/?app=MobRegister");
        break;
      case "register":
        props.history.push("/register/?app=MobRegister");
        break;
      case "skip":
        if (window.mobile?.skipApp) {
          window.mobile?.skipApp();
        }
        break;
      case "policy":
        setOpenPolicy("policy");
        break;
      case "privacyPolicy":
        setOpenPolicy("privacy-policy");
        break;
      case "selectLangue":
        if (typeof window.mobile.getLocaleLanguage === "object") {
          // iOS
          window.mobile?.getLocaleLanguage.then((lang: any) => {
            setSelectLangue(lang);
          });
        } else {
          // android
          const localeLanguage = window.mobile?.getLocaleLanguage();
          setSelectLangue(localeLanguage);
        }
        setOpenSelectLangue(true);

        break;
      case "conditions":
        break;
    }
  };

  const checkDevMode = (patternInput: string) => {
    if (!props.devMode?.devMode) {
      let patternInputFull = pattern + patternInput;
      patternInputFull.substring(patternInputFull.length - 12);
      setPattern(patternInputFull);
    }
  };

  const handleChangeLangue = (langue: any) => {
    console.log("saika ~ langue:", langue);
    if (window.mobile?.setNativeLanguage) {
      // setSelectLangue(langue);
      window.mobile?.setNativeLanguage(langue);
    }
    setOpenSelectLangue(false);
  };

  console.log("saika props", props);

  return (
    <div
      className="main-login"
      style={{ backgroundImage: `url(${IMAGES.bg})`, backgroundSize: "cover" }}
    >
      <div
        className="devMode"
        style={{
          ...(!props.devMode?.devMode && { display: "none" }),
          ...(props.safeAreaTop && { marginTop: "30px" }),
        }}
        onClick={() => {
          setDevModeNative(false, 3);
        }}
      >
        {`devMode ${props.devMode?.devVersion}`}
      </div>
      <div
        className="login-head"
        style={{
          ...(props.safeAreaTop && { paddingTop: `${props.safeAreaTop}px` }),
        }}
      >
        <div className="logo">
          <Image
            src={IMAGES.bPlusLogo}
            style={{ width: "37px" }}
            onClick={() => {
              checkDevMode("1");
            }}
          />
          <div
            onClick={() => {
              checkDevMode("2");
            }}
          >
            {"My B+"}
          </div>
        </div>
        <div className="skip" onClick={() => handleHistoryGoTo("skip")}>
          {<FormattedMessage id="bplusClinicKey970" />}
          <Icon name="arrow right" />
        </div>
      </div>
      <div className="login-image"></div>
      <div className="login-selected">
        <div className="login-selected-head">
          <div>{<FormattedMessage id="bplusClinicKey971" />}</div>
          <div
            className="select-language"
            onClick={() => handleHistoryGoTo("selectLangue")}
          >
            <Image
              src={selectLangue === "en" ? IMAGES.flagUS : IMAGES.flagThai}
              style={{ width: "27px" }}
            />
            <div>{selectLangue === "en" ? "English" : "ภาษาไทย"}</div>
            <div>
              <Icon name="chevron down" />
            </div>
          </div>
        </div>
        <div style={{ width: "100%" }}>
          <div className="bplus-buttom">
            <div
              className="backward"
              style={{
                background: "transparent",
                color: "var(--primary-theme-color)",
                border: `1px solid  var(--primary-theme-color)`,
              }}
              onClick={() => handleHistoryGoTo("login")}
            >
              {<FormattedMessage id="bplusClinicKey958" />}
            </div>
          </div>
          <Divider
            horizontal
            inverted
            style={{ color: "#A2BFC9", fontSize: "14px" }}
          >
            <FormattedMessage id="common.or" />
          </Divider>
          <div className="bplus-buttom">
            <div onClick={() => handleHistoryGoTo("register")}>
              {<FormattedMessage id="bplusClinicKey957" />}
            </div>
          </div>
        </div>

        <div style={{ margin: "10px 0px" }}>
          <div
            style={{
              display: "flex",
              color: "#797878",
              whiteSpace: "nowrap",
              justifyContent: "center",
            }}
          >
            {<FormattedMessage id="bplusClinicKey972" />}
            {
              <span
                className="highlight"
                onClick={() => handleHistoryGoTo("policy")}
              >
                {<FormattedMessage id="bplusClinicKey973" />}
              </span>
            }
          </div>
          <div
            style={{
              display: "flex",
              color: "#797878",
              whiteSpace: "nowrap",
              justifyContent: "center",
            }}
          >
            {<FormattedMessage id="common.and" />}
            {
              <span
                className="highlight"
                onClick={() => handleHistoryGoTo("privacyPolicy")}
              >
                {<FormattedMessage id="bplusClinicKey974" />}
              </span>
            }
            {<FormattedMessage id="bplusClinicKey975" />}
          </div>
        </div>
      </div>

      <Modal
        open={openSelectLangue}
        dimmer={"blurring"}
        onClose={() => setOpenSelectLangue(false)}
      >
        <div className="modal-langue">
          <div className="modal-title">
            {<FormattedMessage id="settings.change_language" />}
            <div className="icon">
              <Icon
                name="close"
                onClick={() => {
                  setOpenSelectLangue(false);
                }}
              />
            </div>
          </div>
          {Langue.map((item: any, index: any) => (
            <div
              key={item.key}
              className="modal-content"
              onClick={() => {
                handleChangeLangue(item.key);
              }}
            >
              <div className="list-item-langue">
                <div>
                  <Image src={item.flag} />
                </div>
                <div>{item.langue}</div>
              </div>
              <div>
                {/* <Radio value={item.key} checked={selectLangue === item.key} /> */}
                <MuiRadio
                  className="smart-radio-button"
                  name="radio-buttons"
                  checked={selectLangue === item.key}
                />
              </div>
              {index !== Langue.length - 1 && <Divider />}
            </div>
          ))}
        </div>
      </Modal>

      <DialogReadMore
        open={openPolicy === "policy"}
        className={classes.dialog}
        onChange={(state) => setOpenPolicy(undefined)}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          {(policy || []).map((item: any) => (
            <div key={`policy-${( item?.key || item?.title || item?.header)?.substring(0, 5)?.replaceAll(" ","")}`}>
              {item.title && (
                <div
                  className="text-black-bold"
                  style={{
                    width: "100%",
                    textAlign: "center",
                    margin: "15px 0 0 0",
                  }}
                >
                  {item.title}
                </div>
              )}
              <div
                className="text-black-bold"
                style={{ fontSize: "16px", margin: "10px 0 0 0" }}
              >
                {item.header}
              </div>
              <div
                className="text-gray"
                style={{
                  whiteSpace: "pre-line",
                }}
              >
                {item.dtailList}
              </div>
            </div>
          ))}
        </div>
      </DialogReadMore>

      <DialogReadMore
        open={openPolicy === "privacy-policy"}
        className={classes.dialog}
        onChange={(state) => setOpenPolicy(undefined)}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          {(props.language === "en-US" ? privacyPolicyEn || [] : privacyPolicy|| []).map((item: any , index:number) => (
            <div key={`privacy-policy-${( item?.key || item?.title || item?.header)?.substring(0, 5)?.replaceAll(" ","")}`}>
              {item.title && (
                <div
                  className="text-black-bold"
                  style={{
                    width: "100%",
                    textAlign: "center",
                    margin: "15px 0 0 0",
                  }}
                >
                  {item.title}
                </div>
              )}
              <div
                className="text-black-bold"
                style={{ fontSize: "16px", margin: "10px 0 0 0" }}
              >
                {item.header}
              </div>
              {item.table ? (
                <TableContainer component={Paper}>
                  <Table aria-label="caption table">
                    <TableHead>
                      <TableRow>
                        {(item.table?.title || []).map((item: any) => (
                          <TableCell key={`privacy-policy-table-head${(item).substring(0, 5)?.replaceAll(" ","")}`}>{item}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(item.table?.detail || []).map((items: any) => (
                        <TableRow>
                          {(items || []).map((item: any) => (
                            <TableCell scope="row" key={`privacy-policy-table-row${(item).substring(0, 5)?.replaceAll(" ","")}-`}>{item}</TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <div
                  className="text-gray"
                  style={{
                    whiteSpace: "pre-line",
                  }}
                >
                  {item.dtailList}
                </div>
              )}
            </div>
          ))}
        </div>
      </DialogReadMore>
    </div>
  );
};

export default React.memo(MainLobby);
